<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>In tragic times like these, an elderly author has nothing to give but words. This collection of words is dedicated to the men and women in many parts of the world who are giving their lives in the cause of freedom and human decency</i>.</p>
<p class="ded1-2"><i>Autumn 1941</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a6f2426a